"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var getNode_1 = __importDefault(require("../fn/getNode"));
var isValidPath_1 = __importDefault(require("../fn/isValidPath"));
/**
 * get
 *
 * Gets a value
 */
var get = function (db) { return function (path) {
    if (!(0, isValidPath_1.default)(path)) {
        return;
    }
    return (0, getNode_1.default)(db, path);
}; };
exports.default = get;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2V0LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2FwaS9nZXQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7QUFBQSwwREFBb0M7QUFDcEMsa0VBQTRDO0FBRTVDOzs7O0dBSUc7QUFDSCxJQUFNLEdBQUcsR0FBRyxVQUFDLEVBQUUsSUFBSyxPQUFBLFVBQUMsSUFBSTtJQUN2QixJQUFJLENBQUMsSUFBQSxxQkFBVyxFQUFDLElBQUksQ0FBQyxFQUFFO1FBQ3RCLE9BQU87S0FDUjtJQUVELE9BQU8sSUFBQSxpQkFBTyxFQUFDLEVBQUUsRUFBRSxJQUFJLENBQUMsQ0FBQztBQUMzQixDQUFDLEVBTm1CLENBTW5CLENBQUM7QUFFRixrQkFBZSxHQUFHLENBQUMifQ==